// extracted by mini-css-extract-plugin
export var copyableField = "_s7-4";
export var customerBadge = "_s7-0";
export var customerInfoTitle = "_s7-2";
export var details = "_s7-1";
export var dropdownContainer = "_s7-5";
export var dropdownImage = "_s7-6";
export var editAssigneeForm = "_s7-a";
export var editButton = "_s7-3";
export var email = "_s7-7";
export var hidden = "_s7-d";
export var input = "_s7-8";
export var saveButton = "_s7-b";
export var shopifyIcon = "_s7-c";
export var suggestionBadge = "_s7-e";
export var suggestionText = "_s7-f";
export var username = "_s7-9";